import { isValidElementType } from 'react-is';
import createShorthand from './createShorthand';
export default function createShorthandFactory(Component, mapValueToProps) {
  if (!isValidElementType(Component)) {
    throw new Error('createShorthandFactory() Component must be a valid React element type.');
  }

  return function (value, options) {
    return createShorthand(Component, mapValueToProps, value, options);
  };
}